import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

type Lang = 'en' | 'pl' | 'es' | 'fr';

export default function PillarArticles() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language as Lang) || 'en';

  return (
    <section id="guides" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="text-center max-w-2xl mx-auto mb-10">
        <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-4xl mb-3">
          {t('pillar.title')}
        </h2>
        <p className="text-foreground-600 text-sm md:text-base">{t('pillar.subtitle')}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {articles.map((article) => {
          const content = article.content[lang] ?? article.content.en;
          return (
            <Link
              key={article.slug}
              to={`/guides/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200 rounded-lg p-5 md:p-6 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold whitespace-nowrap">
                  {t(article.categoryKey)}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-500 whitespace-nowrap">
                  <i className="ri-time-line text-sm" />
                  {article.readTime} {t('article.minRead')}
                </span>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base md:text-lg mb-2 group-hover:text-primary-700 transition-colors">
                {content.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-4 flex-1">
                {content.summary}
              </p>
              <span className="inline-flex items-center gap-1.5 text-primary-700 text-sm font-medium whitespace-nowrap">
                {t('pillar.readMore')}
                <span className="flex items-center justify-center w-4 h-4">
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}